var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMobileSubmenuIcon = function SvgMobileSubmenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M.446 1.883 4.835 6.28.445 10.68l1.352 1.351 5.75-5.75-5.75-5.75z"
  })));
};
export { SvgMobileSubmenuIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDggMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMC40NDU2MjMgMS44ODI1TDQuODM0NzkgNi4yODEyNUwwLjQ0NTYyNCAxMC42OEwxLjc5Njg3IDEyLjAzMTNMNy41NDY4NyA2LjI4MTI1TDEuNzk2ODcgMC41MzEyNTJMMC40NDU2MjMgMS44ODI1WiIgZmlsbD0iIzgwODA4MCIvPgo8L3N2Zz4K";